import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

const selectCustomQuestions = createSelector(getCompany, ({ customQuestions }) => customQuestions);

export const selectCustomQuestionsList = createSelector(selectCustomQuestions, Object.values);

export const selectCustomQuestionById = memoizeOne(customQuestionId =>
  createSelector(selectCustomQuestions, customQuestions => customQuestions[customQuestionId]),
);
